'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultIconLeft = DefaultIconLeft;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ButtonUtils = require('./ButtonUtils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _renderInner(icon, label) {
  return _react2['default'].createElement('span', null, _react2['default'].createElement('i', {
    className: icon,
    'aria-hidden': 'true'
  }), '\xA0', label);
}

function handleOnClick(handleClick) {
  return function (e) {
    e.preventDefault();
    handleClick();
  };
}

function DefaultIconLeft(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      size = _ref.size,
      style = _ref.style,
      disabled = _ref.disabled,
      handleClick = _ref.handleClick;
  var buttonSize = (0, _ButtonUtils.getButtonSize)(size);
  var buttonStyle = (0, _ButtonUtils.getButtonStyle)(style);
  var params = {
    renderInner: function renderInner() {
      return _renderInner(icon, label);
    },
    size: buttonSize,
    style: buttonStyle,
    clickEvent: handleOnClick(handleClick)
  };
  return disabled ? (0, _ButtonUtils.renderDisabledButton)(params) : (0, _ButtonUtils.renderButton)(params);
}

DefaultIconLeft.propTypes = {
  icon: _propTypes2['default'].string,
  label: _propTypes2['default'].string,
  size: _propTypes2['default'].any,
  style: _propTypes2['default'].any,
  disabled: _propTypes2['default'].bool,
  handleClick: _propTypes2['default'].func
};